export default {
  SET_USAGES(state,usages)
  {
    state.usages = usages
  },
  SET_ATTENDANCEPERMONTH2D(state, attendancespermonth2d)
  {
    state.attendancespermonth2d = attendancespermonth2d
  },
  SET_ATTENDANCEPERMONTH(state, attendancespermonth)
  {
    state.attendancespermonth = attendancespermonth
  },
  CREATE_ATTENDANCES (state, item) {
    state.attendances.unshift(item)
  },
  UPDATE_ATTENDANCES (state, attendance) { 
    const attendanceIndex = state.attendances.findIndex((p) => p.id === attendance.id)
    Object.assign(state.attendances[attendanceIndex], attendance)
  },
  SET_SUMMARY_PER_MONTH_0(state, summarypermonth0)
  {
    state.summarypermonth0 = summarypermonth0
  },
  SET_SUMMARY_PER_MONTH_1(state, summarypermonth1)
  {
    state.summarypermonth1 = summarypermonth1
  },
  SET_SUMMARY_PER_MONTH_2(state, summarypermonth2)
  {
    state.summarypermonth2 = summarypermonth2
  },
  SET_ATTENDANCE_BASIC_DATA (state, attendancesbasicdata)
  {
    state.attendancesbasicdata = attendancesbasicdata
  },
  SET_ATTENDANCE (state, attendances) {
    state.attendances = attendances
  },

  CREATE_EMPLOYEES (state, item) {
    state.employees.unshift(item)
  },
 
  SET_EMPLOYEES (state, employees) {
    state.employees = employees
  },

  UPDATE_EMPLOYEES (state, employee) { 
    const employeeIndex = state.employees.findIndex((p) => p.id === employee.id)
    Object.assign(state.employees[employeeIndex], employee)
  }
}
